export default class PortfolioParametrizationCtrl {
  constructor ($scope, $stateParams, $timeout, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, ngYoutubeEmbedService) {
  // constants
    var parametrizationVm = this
    parametrizationVm.userId = JSON.parse($cookies.get('currentUser')).id    
    var activeDefault   = 0
    var activeGuideline = 0
    parametrizationVm.guidelines = []
    parametrizationVm.disableSaveButton = false

    parametrizationVm.addGuideline      = addGuideline
    parametrizationVm.setActiveList     = setActiveList
    parametrizationVm.setActive         = setActive
    parametrizationVm.showModal         = showModal
    parametrizationVm.hasError          = hasError
    parametrizationVm.showErrorMessages = showErrorMessages
    parametrizationVm.validateForm      = validateForm

    activate()

    function activate () {
      getGuidelinesPortfolio()
    }

    function getGuidelinesPortfolio(){
    	PortfolioSrv.getGuidelines.get().$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          parametrizationVm.guidelines = dataReturn.data
        }
      }, function (data) {
          console.log(data)
      })
    }

    function addGuideline(form){
      parametrizationVm.disableSaveButton = true
      let header = {
        title       : parametrizationVm.title,
        description : parametrizationVm.description,
        active      : (parametrizationVm.guidelines.length > 0 ? activeDefault : 1)
      }
      PortfolioSrv.addGuideline.add(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          parametrizationVm.disableSaveButton = false        
          parametrizationVm.guidelines.push(header)
          cleanForm(form)
          activate()
        } else {
          parametrizationVm.disableSaveButton = false
        }
      }, function (data) {
          console.log(data)
      })
    }

    function showModal(guideline){
      let header = {
        guideline : guideline
      }
      PortfolioModalSrv.setVariable(header)
      PortfolioModalSrv.showGuidelineDetails().then((promise) => {        
      })
    }

    function setActive(){
      if (parametrizationVm.active == 1) {
        activeDefault = 0
        parametrizationVm.active = 0
      } else { 
        activeDefault = 1
        parametrizationVm.active = 1 
      }
    }

    function setActiveList(guideline,pos){

      let aux = activeGuideline
      parametrizationVm.guidelines[activeGuideline].active = 0
      parametrizationVm.guidelines[pos].active = 1
      activeGuideline = pos  
      let header = {
        guidelineId : guideline.guidelineId
      }
      PortfolioSrv.updateGuideline.update(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {          
          
        } else {
          activeGuideline = aux  
          parametrizationVm.guidelines[activeGuideline].active = 1
          parametrizationVm.guidelines[pos].active = 0
        }
      }, function (data) {
          console.log(data)
      })    

    }

  //forms functions
    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function validateForm (form) {
      return form.$invalid || parametrizationVm.disableSaveButton
    }

    function cleanForm(form){
      parametrizationVm.title       = ''
      parametrizationVm.description = ''
      parametrizationVm.active      = 0
      activeDefault                 = 0
      form.$setPristine()
      form.$setUntouched()
    }
    

  }
}

PortfolioParametrizationCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'PortfolioSrv', 'PortfolioModalSrv','GlobalConfig', '$cookies', '$state']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/parametrization/portfolioParametrizationCtrl.js